import { render, staticRenderFns } from "./CataloguePostSlide.vue?vue&type=template&id=744f6ba0&lang=pug&"
import script from "./CataloguePostSlide.vue?vue&type=script&lang=js&"
export * from "./CataloguePostSlide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports